import React from "react";
import { Link } from "react-router-dom";
import { AssetConfig } from "../utils/assets";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us">
      {/* Hero Section */}
      <section className="about-hero-section">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">Who we are?</h1>
            <h2 className="about-hero-subtitle">
              Dive-in Panels shapes the products. Your views empower us.
            </h2>
            <div className="about-hero-description">
              <p>
                Combine the strength of an online panel company with the
                accuracy of the technology. And you get Dive-in Panels. Dive-in
                Panels is a fast-growing community of survey respondents. We
                partner with market research companies and brands looking for
                genuine data and customer feedback.
              </p>
              <p>
                If you're are keen to influence the future of a product, join
                hands with us. Because we care about your opinions. And users
                like you enjoy our{" "}
                <Link to="/how-it-works" className="survey-link">
                  best paid online surveys
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="what-we-offer-section">
        <div className="container">
          <h2 className="text-center section-title-purple">What we offer?</h2>
          <p className="text-center section-subtitle-gray">
            We connect brands with their users' views
          </p>
          <div className="row panels justify-content-between">
            <div className="col-md-4">
              <div className="offer-box">
                <div className="offer-content">
                  <figure className="offer-icon">
                    <img
                      alt="Market Research"
                      className="offer-img"
                      src={AssetConfig.images.features.marketResearch}
                    />
                  </figure>
                  <h3 className="offer-title">Market Research</h3>
                  <div className="offer-description">
                    <p>
                      Dive-in Panels provides quality survey responses to your
                      market research campaigns. Now connect with your potential
                      customers' opinions.
                    </p>
                    <p>Refine your products to appeal to your consumers.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="offer-box">
                <div className="offer-content">
                  <figure className="offer-icon">
                    <img
                      alt="Online Community"
                      className="offer-img"
                      src={AssetConfig.images.features.onlineCommunity}
                    />
                  </figure>
                  <h3 className="offer-title">Online Community</h3>
                  <div className="offer-description">
                    <p>
                      You interact with a community of brilliant users. Experts,
                      thought leaders, and enthusiasts. Based on the expertise,
                      interest, and education, surveys are distributed for both
                      B2C and B2B markets.
                    </p>
                    <p>
                      Trustable reviews that help better products and services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="offer-box">
                <div className="offer-content">
                  <figure className="offer-icon">
                    <img
                      alt="Get Rewards"
                      className="offer-img"
                      src={AssetConfig.images.features.reward}
                    />
                  </figure>
                  <h3 className="offer-title">Get Rewards</h3>
                  <div className="offer-description">
                    <p>
                      Fill the surveys curated on your interests. Get paid in
                      exchange for unbiased opinions. Refer your friends and get
                      vouchers.
                    </p>
                    <p>Give way to profits for your time.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="why-join-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="why-opion">
                <p>
                  Find out why you should select us from the best online survey
                  sites in India and the US?
                </p>
                <Link
                  to="/why-join-us"
                  className="btn get-started"
                  tabIndex="0"
                >
                  Why Join Dive-in Panels?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Research Section */}
      <section className="market-research">
        <div className="business-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3 className="page-title text-center">
                  Welcome to the dynamic and emerging
                  <br />
                  world of market research!
                </h3>
                <p className="text-center page-subtitle">
                  Your views matter to the world
                </p>
              </div>
              <div className="col-md-6 align-self-center">
                <figure>
                  <img
                    alt="business"
                    src={AssetConfig.images.features.business}
                  />
                </figure>
              </div>
              <div className="col-md-6 align-self-center">
                <p>
                  Market research is the systematic gathering, recording, and
                  analyzing of data and problems associated with products and
                  services.
                </p>
                <p>
                  When a business identifies a problem and its deemed solution,
                  researchers create objectives and collect feedback from users
                  like you. Survey results help predict market response and
                  shape the proposed solution.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sync-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <p>Your opinions matter to the Market research companies!</p>
                <p>
                  Brands roll out surveys on the best paid survey sites. When
                  you fill these questionnaires, your responses help the brands
                  to refine their products—old and new.
                </p>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-self-center">
                <figure>
                  <img
                    alt="Grow your Business"
                    src={AssetConfig.images.features.sync}
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-center">
              <figure>
                <img
                  alt="Stand Out of the Crowd"
                  src={AssetConfig.images.features.standout}
                />
              </figure>
            </div>
            <div className="col-md-6 align-self-center">
              <p>
                Your opinions enable the brands to understand the requirements
                and desires of the target market better. Your valuable inputs
                define the success or failure of the products and services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Opinion Step Section */}
      <section className="market-research opinion-step-wrapper">
        <div className="business-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h3 className="page-title text-center">
                  The role Dive-in Panels plays
                  <br />
                  between consumers and brands
                </h3>
              </div>
              <div className="col-md-12 text-center">
                <p>
                  Dive-in Panels collects inputs via online mail surveys and
                  questionnaires from qualified individuals addressed to
                  specific demographics. We collate your thoughts on behalf of
                  the market research companies and brands. Market research
                  companies partner with us, and we reward you for your precious
                  time and input.
                </p>
                <p>
                  Whether you live in India or Canada, whether you share your
                  views from Europe or Australia, whether you fill{" "}
                  <Link to="/why-join-us">surveys for money</Link> in the USA or
                  Germany, we connect your opinions with brands globally. Fill
                  from anywhere, anytime, and make bucks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Register CTA Section */}
      <section className="register-cta-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="why-opion pt-0">
                <p>
                  Register with Dive-in Panels today, and let your opinion do
                  the talking!
                </p>
                <Link
                  to="/auth/register"
                  className="btn get-started"
                  tabIndex="0"
                >
                  Register and Start Earning
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
